// extracted by mini-css-extract-plugin
module.exports = {"segmentedControlContainer":"PricingSectionLayout_segmentedControlContainer__llom6","segmentedControlDecoration":"PricingSectionLayout_segmentedControlDecoration__sc6Ms"};